import axios from "axios";
const newBaseUrl = "https://j617xjxwjd.execute-api.ap-south-1.amazonaws.com/axis_bank_prod/getCmsData-V18";
// const newBaseUrl = "https://j617xjxwjd.execute-api.ap-south-1.amazonaws.com/axis_bank_test/getCmsData-V18";

export function apiCallingPost(postData) {
    return axios.post(newBaseUrl, postData)
      .then((data) => data)
      .then((res) => res)
  }